import React, { useContext, useState } from "react";
import ChatContext from "../context";

const ClearChatButton = () => {
  const { store, updateData } = useContext(ChatContext);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleClearChat = () => {
    if (showConfirm) {
      const newData = {
        ...store,
        messages: [],
      };
      updateData(newData);
      setShowConfirm(false);
    } else {
      setShowConfirm(true);
      setTimeout(() => setShowConfirm(false), 3000);
    }
  };

  // Only show if user has sent at least one message (not just the initial greeting)
  const userMessages = store.messages.filter(msg => msg.senderName === store.name);
  if (userMessages.length === 0) {
    return null;
  }

  return (
    <button
      onClick={handleClearChat}
      className={`px-3 py-2 h-[42px] md:h-[44px] rounded-lg text-xs md:text-sm font-semibold transition-all flex-shrink-0 shadow-md flex items-center justify-center ${
        showConfirm
          ? "bg-red-500 hover:bg-red-600 text-white"
          : "bg-gradient-to-b from-[#4940A9] to-[#AE2DC7] hover:from-[#5a4fba] hover:to-[#c03dd8] text-white"
      }`}
      title={showConfirm ? "Click again to confirm" : "Clear all messages"}
    >
      {showConfirm ? "✓ Confirm" : "Clear"}
    </button>
  );
};

export default ClearChatButton;
